module.exports = __webpack_public_path__ + "img/special5.f9569e85.png";